<template>
  <div id="dataLabelManagement" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <!-- <selectStandardId @updateStandardId="updateStandardId" /> -->
        <el-input
          size="small"
          placeholder="标签代码"
          v-model.trim="code"
          clearable
          class="w-200px mr-10px"
        />
        <el-input
          size="small"
          placeholder="标签名称"
          v-model.trim="name"
          clearable
          class="w-200px mr-10px"
        />
        <el-date-picker
          v-model="datetimerange"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="mr-10px"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchTableData()">搜索</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button type="primary" size="small" :disabled="!$hasAccess('create')" @click="goAddLabel"
          >新增</el-button
        >
        <el-button type="danger" size="small" @click="delMore" :disabled="!$hasAccess('delete')"
          >删除</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="toDetail"
          :disabled="!$hasAccess('dataLabel')"
          >数据标签</el-button
        >
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
        height="calc(100% - 106px)"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="$t('labelCode')"
          prop="name"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="$t('labelName')"
          prop="code"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('remarks')}`"
          prop="remark"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="创建时间"
          prop="createdTime"
        ></el-table-column>
        <el-table-column show-overflow-tooltip :label="`${$t('operate')}`" width="160">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="goEditLabel(scope.row)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('delete')"
              @click="delAttr(scope.row.id)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next"
        :total="recordCount"
      ></el-pagination>
      <upload-excel
        ref="excel"
        :customization="true"
        excelType="std/StdAttribute"
        @refreshList="searchTableData"
      ></upload-excel>
    </el-card>

    <!-- 新增和编辑 -->
    <el-dialog
      id="viewDialog"
      width="500px"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      v-dialogDrag
    >
      <el-form label-width="80px" :model="form" :rules="rules" ref="form">
        <el-form-item :label="$t('labelCode')" prop="name">
          <el-input size="small" v-model="form.name" clearable />
        </el-form-item>
        <el-form-item :label="$t('labelName')" prop="code">
          <el-input size="small" v-model="form.code" clearable />
        </el-form-item>
        <el-form-item :label="$t('remarks')">
          <el-input size="small" v-model="form.remark" clearable type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="save" :loading="saveLoading">{{ $t('save') }}</el-button>
        <el-button @click="dialogVisible = false">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uploadExcel from '@/components/upload'
import dataLabelManagementService from '@/services/dataLabelManagementService'
import StdAttributeService from '@/services/StdAttributeService'
// import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dataLabelManagement',
  components: {
    uploadExcel,
    // selectStandardId,
  },
  data() {
    return {
      code: '',
      name: '',
      datetimerange: [],
      totalSelection: [],
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      tableLoading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        code: '',
        name: '',
        remark: '',
        seqNo: 0,
      },
      rules: {
        code: [{ required: true, message: '请输入标签代码', trigger: 'change' }],
        name: [{ required: true, message: '请输入标签名称', trigger: 'change' }],
      },
      saveLoading: false,
      standardId: localStorage.getItem('standardId'),
    }
  },
  filters: {},
  computed: {
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  // watch: {
  //   standardId: {
  //     handler(newVal) {
  //       if (newVal) {
  //         this.searchTableData()
  //       }
  //     },
  //   },
  // },
  async created() {
    this.searchTableData()
  },
  activated() {
    this.searchTableData()
  },
  methods: {
    // updateStandardId(val) {
    //   this.standardId = val
    // },
    toDetail() {
      this.$router.push('./data-label-detail')
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const params = _.cloneDeep(this.form)
          // params.standardId = this.standardId
          let res
          if (this.form.id) {
            res = await dataLabelManagementService.update(params)
          } else {
            res = await dataLabelManagementService.create(params)
          }
          this.saveLoading = false
          if (res && res.code === 0) {
            this.$message.success('保存成功')
            this.searchTableData()
            this.dialogVisible = false
            this.form = this.$options.data().form
          }
        }
      })
    },
    handleSelectionChange(val) {
      this.totalSelection = val
    },
    goAddLabel() {
      this.dialogTitle = '新增标签'
      this.dialogVisible = true
      this.form = this.$options.data().form
      this.form.seqNo = this.recordCount + 1
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    async searchTableData() {
      this.tableLoading = true
      const parameter = {
        Name: this.name,
        Code: this.code,
        SkipCount: this.pageNo,
        MaxResultCount: this.pageSize,
        StartTime:
          this.datetimerange && this.datetimerange.length && this.datetimerange[0]
            ? this.datetimerange[0]
            : '',
        EndTime:
          this.datetimerange && this.datetimerange.length && this.datetimerange[1]
            ? this.datetimerange[1]
            : '',
        // StandardId: this.standardId,
      }
      const res = await dataLabelManagementService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        _.forEach(this.tableData, (item) => {
          if (_.find(this.totalSelection, ['id', item.id])) {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            })
          }
        })
        this.recordCount = res.totalCount
        this.tableLoading = false
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.doLayout()
          }
        })
      }
    },
    importExperience() {
      this.$refs.excel.uploadExcelVisible = true
    },
    async exportFile() {
      const res = await StdAttributeService.exportFile({
        downloadFileName: '',
        // urlParam: `?standard_id=${this.standardId}`,
        ids: _.map(this.totalSelection, (item) => {
          return item.id
        }),
        downloadType: 0,
      })
      if (res && res.data && res.code === 0) {
        window.location.href = `${currentEnv.VUE_APP_STANDARD_SERVER}/${res.data}`
      }
    },
    reset() {
      this.name = ''
      this.code = ''
      this.datetimerange = []
      this.tableData = []
      this.searchTableData()
    },
    delAttr(id) {
      this.$confirm('是否确定要删除该标签', this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await dataLabelManagementService.remove({ data: [id] })
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            this.searchTableData()
          }
        })
        .catch(() => {})
    },
    delMore() {
      if (!this.totalSelection.length) {
        this.$message({
          type: 'warning',
          message: '请选择要删除的数据!',
        })
        return
      }
      const ids = this.totalSelection.map((item) => {
        return item.id
      })
      this.$confirm('是否确定要删除所选数据!', this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await dataLabelManagementService.remove({ data: ids })
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            this.searchTableData()
          }
        })
        .catch(() => {})
    },
    goEditLabel(row) {
      this.dialogTitle = '编辑标签'
      this.dialogVisible = true
      this.form = _.cloneDeep(row)
    },
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.searchTableData()
    },
  },
}
</script>
<style lang="scss" scoped>

#dataLabelManagement {
  // /deep/.el-input-number.is-without-controls .el-input__inner {
  //   text-align: left;
  // }
  .formHeight {
    height: 45px;
  }
  .titleBox {
    justify-content: space-between;
    align-items: center;
  }
  .divider {
    height: 1px;
    border-bottom: 1px solid #dcdcdc;
    flex: 1;
  }
}

</style>
